// extracted by mini-css-extract-plugin
export default {"faqimage":"FAQ_faqimage__G4Oa1","Header":"FAQ_Header__PP461","Content":"FAQ_Content__RUisF","Topic":"FAQ_Topic__CIS9V","Details":"FAQ_Details__w61ut","a":"FAQ_a__eZdun"};